/** Add or remove @see className on @see element. */
export function setElementClassEnabled(
  element: Element | null,
  className: string,
  enabled: boolean
) {
  const method = (enabled) ? 'add' : 'remove';
  element?.classList[method](className);
}
